"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchField = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _HydratedContent = require("b2b-components/core/components/HydratedContent");
var _Icon = require("b2b-components/theme/components/Icon");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
require("./SearchField.scss");
const SearchField = _ref => {
  let {
    onClick,
    onSubmit,
    onInputChange,
    onInputKeyDown,
    onClearButtonClick,
    onScanCodeButtonClick,
    hasScanCodeButton,
    value,
    isLoading,
    placeholder,
    deviceType,
    inputRef,
    dataAttributes,
    closeButtonDataAttributes,
    submitButtonDataAttributes,
    className
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-SearchField', {
    [`cds-SearchField--${(0, _upperCase.upperCaseFirst)(deviceType || '')}`]: deviceType
  }, className);
  return /*#__PURE__*/_react.default.createElement("form", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName,
    role: "search",
    onSubmit: onSubmit
  }), /*#__PURE__*/_react.default.createElement("input", {
    autoComplete: "off",
    className: "cds-SearchField-TextInput",
    onChange: onInputChange,
    onClick: onClick,
    onKeyDown: onInputKeyDown,
    placeholder: placeholder,
    ref: inputRef,
    type: "text",
    value: value
  }), hasScanCodeButton && /*#__PURE__*/_react.default.createElement("button", {
    className: "cds-SearchField-ScanCodeButton",
    onClick: onScanCodeButtonClick,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-HideVisibility"
  }, "Scan Code"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.codeScanner
  })), /*#__PURE__*/_react.default.createElement(_HydratedContent.HydratedContent, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!value.length && isLoading && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-SearchField-IconLoader",
    name: _Icon.ICON_NAME.loader
  }), !!value.length && /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    className: "cds-SearchField-CloseButton",
    onClick: onClearButtonClick,
    type: "button"
  }, (0, _getComponentDataAttributes.getComponentDataAttributes)(closeButtonDataAttributes)), /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-HideVisibility"
  }, "Close Search"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.close
  })))), /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    className: "cds-SearchField-SubmitButton",
    type: "submit"
  }, (0, _getComponentDataAttributes.getComponentDataAttributes)(submitButtonDataAttributes)), /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-HideVisibility"
  }, "Submit Search"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.search
  })));
};
exports.SearchField = SearchField;
//# sourceMappingURL=SearchField.js.map